import { render } from "./CIS-List-Page-Right-Rail.vue?vue&type=template&id=2d70d3c0&scoped=true"
import script from "./CIS-List-Page-Right-Rail.vue?vue&type=script&lang=js"
export * from "./CIS-List-Page-Right-Rail.vue?vue&type=script&lang=js"

import "./CIS-List-Page-Right-Rail.vue?vue&type=style&index=0&id=2d70d3c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d70d3c0"]])

export default __exports__